import React from "react";
import "../../Css/Services.css";

const Services = () => {
  const services = [
    {
      icon: "💻",
      title: "Custom Website Development",
      description:
        "Modern, responsive websites built with latest technologies",
    },
    {
      icon: "🛒",
      title: "E-commerce Solutions",
      description:
        "Scalable e-commerce platforms for retail success",
    },
    {
      icon: "⚡",
      title: "Web Applications",
      description:
        "Powerful web apps for complex business operations",
    },
    {
      icon: "📊",
      title: "Business Software",
      description:
        "Billing, inventory, and management systems",
    },
    {
      icon: "🎨",
      title: "UI/UX Design",
      description:
        "Beautiful, intuitive interfaces that users love",
    },
    {
      icon: "🛠",
      title: "Maintenance & Support",
      description:
        "Ongoing support and continuous improvement",
    },
  ];

  return (
    <section className="services-section">
      {/* Background Glow */}
      <div className="services-glow"></div>

      <div className="services-container">
        {/* Heading */}
        <div className="services-top">
          <div className="services-badge">
            <span className="services-dot"></span>
            OUR SERVICES
          </div>

          <h2 className="services-title">
            Our <span>Services</span>
          </h2>

          <p className="services-description">
            Comprehensive solutions tailored to your business needs
          </p>
        </div>

        {/* Cards */}
        <div className="services-grid">
          {services.map((service, index) => (
            <div className="service-card" key={index}>
              <div className="service-icon">{service.icon}</div>

              <h3>{service.title}</h3>

              <p>{service.description}</p>

              {/* <button className="learn-btn">
                Learn More →
              </button> */}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;